'use client';

import { useEffect, useState } from 'react';
import FreeStar from '@/components/freeStar';

interface ResourceAdProps {
  category: string;
  position: 'top' | 'right_secondary' | 'right' | 'bot';
}

const mapping: { [key: string]: string } = {
  'Home & Family': 'Family',
  School: 'School',
  'Groups & Clubs': 'Groups',
  Sports: 'Sports',
  Nonprofits: 'NonProfit',
  College: 'College',
  Business: 'Business',
  Church: 'Church',
  blog: 'Blog',
};

const ResourceAd = ({ category, position }: ResourceAdProps) => {
  const [width, setWidth] = useState(1024); // Default to desktop width

  useEffect(() => {
    // Set initial width
    setWidth(window.innerWidth);
  }, []);

  const getAdSize = (position: string, width: number) => {
    if (position === 'top') {
      return width >= 1024 ? '728x90' : '320x50';
    }
    if (position === 'right_secondary') {
      return '300x250';
    }
    if (position === 'right') {
      return '300x600';
    }
    if (position === 'bot') {
      return '810x250';
    }
    return '';
  };

  const getPlacementName = () => {
    // Don't show right_secondary and right ads on tablet/mobile
    if (
      width < 1024 &&
      (position === 'right_secondary' ||
        position === 'right' ||
        position === 'bot')
    ) {
      return null;
    }

    const base = 'signupgenius_Desktop_Resources_';
    const categoryName = mapping[category] || 'Main';
    const adSize = getAdSize(position, width);
    const positionString =
      position === 'right_secondary'
        ? '_Right_secondary'
        : position === 'right'
          ? '_Right'
          : position === 'bot'
            ? '_Bot'
            : '_Top';

    return `${base}${categoryName}_${adSize}${positionString}`;
  };

  const placementName = getPlacementName();

  // Don't render anything if no valid placement name
  if (!placementName) return null;

  return <FreeStar placementName={placementName} />;
};

export default ResourceAd;

/* 
signupgenius_Desktop_Resources_Family_728x90_Top - Home & family category resource
signupgenius_Desktop_Resources_Main_728x90_Top - no idea
signupgenius_Desktop_Resources_School_728x90_Top - school category resource
signupgenius_Desktop_Resources_Groups_728x90_Top - group & clubs category resource
signupgenius_Desktop_Resources_Sports_728x90_Top - sports category resource
signupgenius_Desktop_Resources_NonProfit_728x90_Top - non profit category resource
signupgenius_Desktop_Resources_College_728x90_Top - college category resource
signupgenius_Desktop_Resources_Business_728x90_Top - business category resource
signupgenius_Desktop_Resources_Church_728x90_Top - church category resource
signupgenius_Desktop_Resources_Blog_728x90_Top - no idea

signupgenius_Desktop_Resources_Sports_300x250_Right_secondary
signupgenius_Desktop_Resources_Church_300x250_Right_secondary
signupgenius_Desktop_Resources_Business_300x250_Right_secondary
signupgenius_Desktop_Resources_College_300x250_Right_secondary
signupgenius_Desktop_Resources_Blog_300x250_Right_secondary
signupgenius_Desktop_Resources_Nonprofit_300x250_Right_secondary
signupgenius_Desktop_Resources_Family_300x250_Right_secondary
signupgenius_Desktop_Resources_Groups_300x250_Right_secondary
signupgenius_Desktop_Resources_Main_300x250_Right_secondary

signupgenius_Desktop_Resources_Business_300x600_Right
signupgenius_Desktop_Resources_School_300x600_Right
signupgenius_Desktop_Resources_NonProfit_300x600_Right
signupgenius_Desktop_Resources_Blog_300x600_Right
signupgenius_Desktop_Resources_Groups_300x600_Right
signupgenius_Desktop_Resources_Family_300x600_Right
signupgenius_Desktop_Resources_Sports_300x600_Right
signupgenius_Desktop_Resources_College_300x600_Right
signupgenius_Desktop_Resources_Main_300x600_Right
signupgenius_Desktop_Resources_Church_300x600_Right

signupgenius_Desktop_Resources_Business_810x250_Bot
signupgenius_Desktop_Resources_Family_810x250_Bot
signupgenius_Desktop_Resources_Church_810x250_Bot
signupgenius_Desktop_Resources_School_810x250_Bot
signupgenius_Desktop_Resources_Sports_810x250_Bot
signupgenius_Desktop_Resources_Blog_810x250_Bot
signupgenius_Desktop_Resources_NonProfit_810x250_Bot
signupgenius_Desktop_Resources_Main_810x250_Bot
signupgenius_Desktop_Resources_Groups_810x250_Bot
signupgenius_Desktop_Resources_College_810x250_Bot
*/
